export default __webpack_public_path__ + "static/media/Xartina_koytia.a3f49ccf.jpg";